import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { isSafeInternalReturnUrl } from "../constants/post-login-redirect.constants";
import { AuthStateService } from "../services/auth-state.service";

/**
 * Guard para rutas de autenticación (login/forgot/reset/select-tenant).
 * Si hay sesión activa, evita volver a login y redirige según contexto.
 */
export const noAuthGuard: CanActivateFn = (route): boolean | UrlTree => {
  const authState = inject(AuthStateService);
  const router = inject(Router);
  const currentAuthPath = route.routeConfig?.path;

  const isAuthenticated = authState.isAuthenticated();

  if (!isAuthenticated) {
    return true;
  }

  const returnUrl = route.queryParamMap.get("returnUrl");
  const targetUrl = isSafeInternalReturnUrl(returnUrl) ? returnUrl : "/home";

  if (currentAuthPath === "login") {
    return router.createUrlTree([targetUrl]);
  }

  return router.createUrlTree([targetUrl]);
};
